import { Icons } from "atoms/constants/icons";
import SubscriptionType from "organisms/enums/subscription-type";
import SubscriptionCard from "organisms/subscription-card/subscription-card";
import SubscriptionFeatureList from "organisms/subscription-card/subscription-feature-list";
import { SubscriptionCardUtils } from "organisms/subscription-cards/subscription-card-utils";
import React from "react";
import { SubscriptionFeaturesType } from "utilities/hooks/domain/subscriptions/use-subscription-features";
import { useEcommercePrices } from "utilities/hooks/use-ecommerce-prices";
import { useLocalization } from "utilities/hooks/use-localization";

// -----------------------------------------------------------------------------------------
// #region Interfaces
// -----------------------------------------------------------------------------------------

export interface IndividualSubscriptionCardProps {
    onSelect: () => void;
    cssClassNameModifier?: string;
}

// #endregion Interfaces

// -----------------------------------------------------------------------------------------
// #region Component
// -----------------------------------------------------------------------------------------

const IndividualSubscriptionCard: React.FunctionComponent<
    IndividualSubscriptionCardProps
> = (props: IndividualSubscriptionCardProps) => {
    const { onSelect, cssClassNameModifier = "" } = props;
    const { t } = useLocalization();

    const { ecommercePrices } = useEcommercePrices();

    return (
        <SubscriptionCard
            billingText={t("subscriptionCard-individual-billingText")}
            buttonText={t("subscriptionCard-individual-buttonText")}
            headingIcon={Icons.Individual}
            onSelect={onSelect}
            price={SubscriptionCardUtils.getPricingText(
                ecommercePrices?.IndividualMonthlyAutoRenew ?? ""
            )}
            type={SubscriptionType.Individual}
            cssClassNameModifier={cssClassNameModifier}>
            <SubscriptionFeatureList
                type={SubscriptionFeaturesType.Individual}
            />
        </SubscriptionCard>
    );
};

// #endregion Component

// -----------------------------------------------------------------------------------------
// #region Export
// -----------------------------------------------------------------------------------------

export default IndividualSubscriptionCard;

// #endregion Export
